import { LaneType } from 'common-types';

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use AttachmentTypeEnum from application-types instead.
 */
export enum AttachmentTypeEnum {
  Image = 'Image',
  Document = 'Document',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use AttachmentImageContentTypeEnum from application-types instead.
 */
export enum AttachmentImageContentTypeEnum {
  png = 'image/png',
  jpeg = 'image/jpeg',
  jpg = 'image/jpg',
  gif = 'image/gif',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use AttachmentDocumentContentTypeEnum from application-types instead.
 */
export enum AttachmentDocumentContentTypeEnum {
  pdf = 'application/pdf',
  csv = 'text/csv',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use Attachment from application-types instead.
 */
export type Attachment = {
  id: LaneType.UUID;
  entityId: LaneType.UUID;
  entityType: EntityTypeEnum;
  file: LaneType.JSON;
  thumbnail: LaneType.JSON;
  created: Date;
  deletedAt: Date | null;
  s3Bucket: string;
};

// Corresponds to packages/lane-shared/graphql/attachment/createAttachment.ts
/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentResponse from application-types instead.
 */
export type AttachmentResponse = Attachment & {
  fileSignedUrl: string | null;
  thumbnailSignedUrl: string | null;
};

// This object refers to draft attachments when default OS selector select the files
/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentPreview from application-types instead.
 */
export type AttachmentPreview = {
  entityId?: string;
  id: LaneType.UUID;
  fileUrl: string;
  file: LaneType.JSON;
};

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use EntityTypeEnum from application-types instead.
 */
export enum EntityTypeEnum {
  Content = 'ContentAttachment',
  Static = 'ContentAttachment',
  Perk = 'ContentAttachment',
  Promotion = 'ContentAttachment',
  WorkOrder = 'WorkOrderAttachment',
  Equipment = 'EquipmentAttachment',
  PMSchedule = 'PMScheduleAttachment',
  PMTask = 'PMTaskAttachment',
  ImporterAttachment = 'ImporterAttachment',
  VisitorAttachment = 'VisitorAttachment',
}

/**
 * @deprecated This enum is deprecated and should not be used in new code.
 * Use AttachmentVariantEnum from application-types instead.
 */
export enum AttachmentVariantEnum {
  Receipt = 'receipt',
  WorkOrder = 'workorder',
  Visitor = 'visitor',
}

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentEntityInput from application-types instead.
 */
export type AttachmentEntityInput = {
  type: EntityTypeEnum;
  id: LaneType.UUID;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentFilePayload from application-types instead.
 */
export type AttachmentFilePayload = {
  name: string;
  size: number;
  type: string;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentThumbnailPayload from application-types instead.
 */
export type AttachmentThumbnailPayload = {
  name: string;
  size: number;
  width: number;
  height: number;
  type: string;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentDataForUpload from application-types instead.
 */
export type AttachmentDataForUpload = {
  attachment: AttachmentFilePayload;
  attachmentBlob: Blob;
  thumbnail?: AttachmentThumbnailPayload;
  thumbnailBlob?: Blob;
  s3Bucket: string;
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentPreviewMobile from application-types instead.
 */
export type AttachmentPreviewMobile = {
  entityId?: string;
  created?: Date; // to determine if its exists in db
  id: LaneType.UUID;
  fileUrl: string;
  // file node adapted from DocumentPickerResponse in lane-mobile
  file: {
    uri: string;
    name: string;
    copyError?: string;
    fileCopyUri: string | null;
    type: string | null;
    size: number | null;
    height?: number;
    width?: number;
    thumbnailUri?: string | null;
  };
};

/**
 * @deprecated This type is deprecated and should not be used in new code.
 * Use AttachmentField from application-types instead.
 */
export type AttachmentField = {
  customGeneratedId: string;
  attachments?: Array<JSON>;
};
